import React from "react";
import ConnectUs from "../Contact.js/ConnectUs";
import Aboutme from "../Home/AboutMe/Aboutme";

const About = () => {
  return (
    <div>
      <Aboutme></Aboutme>
      <ConnectUs></ConnectUs>
    </div>
  );
};

export default About;
